import React from 'react';
import { motion } from 'framer-motion';

function Hero() {
  const heroImage = "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?q=80&w=2070";

  return (
    <section className="pt-8 pb-16 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="relative min-h-[600px] rounded-[3.5rem] overflow-hidden shadow-2xl bg-slate-900">
          
          {/* Background Image - SEO: Alt text optimized */}
          <div className="absolute inset-0 z-0">
            <img 
              src={heroImage} 
              alt="ZYGMA Global Digital Growth and SEO Agency" 
              className="w-full h-full object-cover opacity-40" 
            />
            <div className="absolute inset-0 bg-gradient-to-r from-slate-900 via-slate-900/60 to-transparent"></div>
          </div>

          {/* Content Area */}
          <div className="relative z-10 flex flex-col justify-center h-full min-h-[600px] px-8 md:px-20 py-20 lg:w-2/3">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <span className="bg-blue-600/20 text-blue-400 border border-blue-500/30 px-4 py-2 rounded-full text-xs font-bold uppercase tracking-widest mb-6 inline-block">
                Global Strategic Digital Agency
              </span>
              
              {/* SEO: H1 is the most important tag. Worldwide keywords added. */}
              <h1 className="text-5xl md:text-7xl font-black text-white leading-[1.1] mb-8">
                Scale Your <br />
                <span className="text-blue-500">Worldwide Market.</span>
              </h1>
              
              {/* SEO: Updated description to target international clients */}
              <p className="text-gray-300 text-lg md:text-xl mb-12 max-w-xl leading-relaxed">
                Expert GMB Optimization, Professional Web Solutions, and AI-Driven Growth Strategies for global brands and businesses looking to dominate search results.
              </p>

              <div className="flex flex-wrap gap-5">
                <a 
                  href="#services" 
                  className="bg-blue-600 hover:bg-blue-700 text-white px-10 py-4 rounded-2xl font-bold transition-all transform hover:scale-105 shadow-xl shadow-blue-600/20 text-center"
                >
                  Get Started
                </a>
              </div>
            </motion.div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Hero;